import { Module } from 'vuex';
import {
	filter,
	getItemListData,
	itemIsDonated,
} from '@/store/collection-helpers';
import { convertToCurrentVersion, currentVersion } from '@/store/version';

interface Item {
	donated: boolean;
	endsBy?: string;
	availableBy?: string;
	hoursBy?: string;
}

const groups: { [key: string]: string[] } = {
	museum: ['bug', 'fish', 'sea', 'art'],
	others: ['music', 'recipe'],
	wardrobe: [
		'tops',
		'bottoms',
		'dresses',
		'headwear',
		'accessories',
		'socks',
		'shoes',
		'bags',
		'umbrellas',
	],
};

export interface CollectionState {
	filters: {
		donated: null | boolean;
		endsBy: null | string;
		availableBy: null | string;
		hoursBy: null | string;
	};
	collection: { [key: string]: any[] };
	version: string;
}

function routeParamOrNull(route: any, paramKey: string) {
	if (!route || !route.params || !route.params[paramKey]) return null;
	return route.params[paramKey];
}

// eslint-disable-next-line @typescript-eslint/ban-types
const collectionModule: Module<CollectionState, {}> = {
	getters: {
		filters: (state) => state.filters,
		filtersAvailable: (state, getters) => {
			if (!getters.group) return [];
			const isAllSelected = getters.itemType === null;
			const itemType = isAllSelected
				? getters.itemListKeys[0]
				: getters.itemType;
			const item = getItemListData(itemType)[0];
			const filtersAvailable = ['donated'];
			if (item.hoursBy) filtersAvailable.push('hoursBy');
			if (item.endsBy) filtersAvailable.push('endsBy');
			if (item.availableBy) filtersAvailable.push('availableBy');
			return filtersAvailable;
		},
		itemList: (state, getters) => (itemType: string, group: string) => {
			return getItemListData(itemType).map((i: any) => ({
				...i,
				group,
				donated: itemIsDonated(state.collection[itemType], i),
				hidden: !filter(
					state.filters,
					getters.filtersAvailable
				)({
					...i,
					donated: itemIsDonated(state.collection[itemType], i),
				}),
			}));
		},
		fileContents: (state) => ({
			filters: state.filters,
			collection: state.collection,
			version: state.version,
		}),
		group: (state, getters, rootState: any): string | null => {
			return routeParamOrNull(rootState.route, 'itemCategory');
		},
		itemType: (state, getters, rootState: any): string | null => {
			return routeParamOrNull(rootState.route, 'itemType');
		},
		itemListKeys: (state, getters) => {
			if (!getters.group) return null;
			return groups[getters.group];
		},
	},
	state: () => ({
		filters: {
			donated: null,
			endsBy: null,
			availableBy: null,
			hoursBy: null,
		},
		collection: {},
		version: currentVersion,
	}),
	mutations: {
		toggleFilter(
			state,
			{
				filter,
				value,
			}: {
				filter: 'availableBy' | 'endsBy' | 'hoursBy' | 'donated';
				value: any;
			}
		) {
			if (state.filters[filter] === value) {
				state.filters[filter] = null;
			} else {
				state.filters[filter] = value;
				if (filter === 'availableBy') state.filters.endsBy = null;
				if (filter === 'endsBy') state.filters.availableBy = null;
			}
			console.log(state.filters);
		},
		toggleItem(state, { itemType, item }) {
			if (!state.collection[itemType]) state.collection[itemType] = [];
			const itemIsDonated = state.collection[itemType].indexOf(item.index);
			if (itemIsDonated === -1) {
				state.collection[itemType].push(item.index);
			} else {
				state.collection[itemType].splice(itemIsDonated, 1);
			}
			console.log(state.collection);
		},
		setCollection: (state, file) => {
			const converted = convertToCurrentVersion(file);
			console.log({ file }, { converted });
			state.filters = converted.filters;
			state.collection = converted.collection;
			console.log({ state });
		},
	},
	actions: {
		toggleFilter: async function ({ commit, dispatch }, payload) {
			commit('toggleFilter', payload);
			await dispatch('updateSavedFile');
		},
		toggleItem: async function ({ commit, dispatch }, payload) {
			commit('toggleItem', payload);
			await dispatch('updateSavedFile');
		},
	},
};

export default collectionModule;
